export default __webpack_public_path__ + "static/media/easyTwo.3b83d6a7.png";